import React from "react";
import RichText from "./RichText";
import { secureAssetUrl } from "../../lib/secureUrl";
import {
  Heading,
  Callout,
  Toggle,
  NotionTable,
  Columns,
  ListItem,
  Quote,
  Paragraph,
  CodeBlock,
  ImageBlock,
  Mermaid,
  Artifact,
} from "./nodeComponents";

const renderBlock = (node, i) => {
  switch (node.type) {
    case "heading":
      return <Heading key={node.id || i} node={node} />;
    case "paragraph":
      return <Paragraph key={node.id || i} node={node} />;
    case "callout":
      return <Callout key={node.id || i} node={node} />;
    case "toggle":
      return <Toggle key={node.id || i} node={node} />;
    case "quote":
      return <Quote key={node.id || i} node={node} />;
    case "divider":
      return <hr key={node.id || i} className="my-8 border-0 border-t border-dashed border-pillet-sage/60" />;
    case "mermaid":
      return <Mermaid key={node.id || i} code={node.code} />;
    case "code":
      return <CodeBlock key={node.id || i} node={node} />;
    case "artifact":
      return <Artifact key={node.id || i} blockId={node.id} label={node.label} />;
    case "embed":
      return (
        <a key={node.id || i} href={secureAssetUrl(node.url)} target="_blank" rel="noopener noreferrer" className="text-pillet-sage underline block my-3">
          {node.url}
        </a>
      );
    case "image":
    case "video":
    case "file":
    case "pdf":
      return <ImageBlock key={node.id || i} node={node} />;
    case "table":
      return <NotionTable key={node.id || i} node={node} />;
    case "column_list":
      return <Columns key={node.id || i} node={node} />;
    default:
      return null;
  }
};

const BlocksRenderer = ({ nodes }) => {
  if (!nodes) return null;
  const out = [];
  let i = 0;
  while (i < nodes.length) {
    const n = nodes[i];

    if (n.type === "bulleted_list_item") {
      const group = [];
      while (i < nodes.length && nodes[i].type === "bulleted_list_item") {
        group.push(nodes[i]);
        i++;
      }
      out.push(
        <ul key={`ul-${i}`} className="my-3 space-y-1.5 pl-1">
          {group.map((item) => (
            <ListItem key={item.id} item={item} marker="•" />
          ))}
        </ul>
      );
      continue;
    }

    if (n.type === "numbered_list_item") {
      const group = [];
      while (i < nodes.length && nodes[i].type === "numbered_list_item") {
        group.push(nodes[i]);
        i++;
      }
      out.push(
        <ol key={`ol-${i}`} className="my-3 space-y-1.5 pl-1 list-none">
          {group.map((item, gi) => (
            <ListItem key={item.id} item={item} marker={`${gi + 1}.`} />
          ))}
        </ol>
      );
      continue;
    }

    if (n.type === "to_do") {
      out.push(
        <div key={n.id} className="flex gap-3 my-1.5 text-white/85">
          <span className="text-pillet-sage">{n.checked ? "☑" : "☐"}</span>
          <span className={n.checked ? "line-through text-pillet-muted" : ""}>
            <RichText spans={n.spans} />
          </span>
        </div>
      );
      i++;
      continue;
    }

    out.push(renderBlock(n, i));
    i++;
  }
  return <>{out}</>;
};

export default BlocksRenderer;
